import dynamic from 'next/dynamic'
import { ErrorBoundary } from '../src/components/ErrorBoundary'

const TermsOfService = dynamic(() => import('../src/pages/TermsOfService'), {
  ssr: false,
})

export default function Terms() {
  return (
    <ErrorBoundary>
      <TermsOfService />
    </ErrorBoundary>
  )
}